module.exports = __webpack_public_path__ + "static/img/ao_spine_white_rgb.a368585.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ao_spine_white_rgb.png
// module id = sUNr
// module chunks = 1